"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fdatetime_1 = require("./fdatetime");
var padNumber_1 = require("./padNumber");
var datePart_1 = require("./datePart");
/**
 * Zwraca tablicę zawierającą listę miesięcy pomiędzy datami
 * @param startDate data początkowa
 * @param endDate data końcowa
 * @param format format, domyślnie MMMM yyyy, czyli "styczeń 2019"
 */
function listMonths(startDate, endDate, format /* = 'MMMM yyyy'*/) {
    /*
      const dt1 = dateParse(startDate);
      const dt2 = dateParse(endDate);

      let m1 = dt1.getMonth();
      let y1 = dt1.getFullYear();
      const m2 = dt2.getMonth();
      const y2 = dt2.getFullYear();
      */
    var m1 = datePart_1.default(startDate, 'M') - 1;
    var y1 = datePart_1.default(startDate, 'y');
    var m2 = datePart_1.default(endDate, 'M') - 1;
    var y2 = datePart_1.default(endDate, 'y');
    var result = [];
    var func;
    switch (format) {
        case 'MMMM yyyy':
            func = function (m, y) { return fdatetime_1.monthNames[m] + ' ' + y; };
            break;
        case 'MMM yyyy':
            func = function (m, y) { return fdatetime_1.monthShort[m] + ' ' + y; };
            break;
        case 'MM yyyy':
            func = function (m, y) { return padNumber_1.default(m + 1) + ' ' + y; };
            break;
        case 'M yyyy':
            func = function (m, y) { return m + 1 + ' ' + y; };
            break;
        case 'MMMM':
            func = function (m, y) { return fdatetime_1.monthNames[m]; };
            break;
        case 'MMM':
            func = function (m, y) { return fdatetime_1.monthShort[m]; };
            break;
        case 'MM':
            func = function (m, y) { return padNumber_1.default(m + 1); };
            break;
        case 'M':
            func = function (m, y) { return (m + 1).toString(); };
            break;
        default:
            func = function (m, y) { return fdatetime_1.monthNames[m] + ' ' + y; };
            break;
    }
    while ((m1 <= m2 && y1 === y2) || y1 < y2) {
        result.push(func(m1, y1));
        m1++;
        if (m1 > 11) {
            m1 = 0;
            y1++;
        }
    }
    return result;
}
exports.default = listMonths;
//# sourceMappingURL=listMonths.js.map